var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSessionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#C6DDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 35C15.5333 35 15.3542 34.9292 15.2125 34.7875C15.0708 34.6458 15 34.4667 15 34.25C15 34.0333 15.0708 33.8542 15.2125 33.7125C15.3542 33.5708 15.5333 33.5 15.75 33.5H36.25C36.4667 33.5 36.6458 33.5708 36.7875 33.7125C36.9292 33.8542 37 34.0333 37 34.25C37 34.4667 36.9292 34.6458 36.7875 34.7875C36.6458 34.9292 36.4667 35 36.25 35H15.75ZM17.5 32C17.1 32 16.75 31.85 16.45 31.55C16.15 31.25 16 30.9 16 30.5V18.5C16 18.1 16.15 17.75 16.45 17.45C16.75 17.15 17.1 17 17.5 17H34.5C34.9 17 35.25 17.15 35.55 17.45C35.85 17.75 36 18.1 36 18.5V30.5C36 30.9 35.85 31.25 35.55 31.55C35.25 31.85 34.9 32 34.5 32H17.5Z",
    fill: "#1A2CCE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionsIcon);
export default __webpack_public_path__ + "static/media/sessions_icon.b0b0d45d637772a6524fddf31c2b6c5b.svg";
export { ForwardRef as ReactComponent };